import { VATId, VatRate } from '../types';
import { client } from './axiosClient';

export const getInProgressClientVATIds = async (company_id?: string) => {
  const res = await client.get<VATId[]>('/client/vat-ids/in-progress', {
    params: {
      company_id,
    },
  });
  return res.data;
};
export const getRegisteredVATIds = async (company_id?: string) => {
  const res = await client.get<VATId[]>('/client/vat-ids/registered', {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const getVatRates = async () => {
  const res = await client.get<VatRate[]>('/vat-rate');
  return res.data;
};
